/** Imports */
import React from 'react';
import styles from './style.module.css';
import {BarLoader} from 'react-spinners';


/** Types */
type Props = Readonly<{
    color?: string;
    cssOverride?: React.CSSProperties;
}>;


/** Component */
export default function Loading(props: Props) {
    const {color, cssOverride} = props;


    // Render
    return (
        <div className={styles.Loading} style={cssOverride} data-loading-indicator="true">
            <BarLoader
                color={(color)
                    ? color
                    : 'rgb(var(--color-primary-light))'}
                width={128}
            />
        </div>
    );
}
